import { PUT_CREDENTIALS } from './action';

const initialState = null;

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case PUT_CREDENTIALS:
        return action.payload 
    default: {
      return state;
    }
  }
};

export default reducer;
